/**
 * Contador de pendências e "Sincronizar agora".
 *
 * Existe porque o iOS não tem Background Sync: sem uma ação explícita, uma
 * despesa criada offline ficaria parada sem que a pessoa soubesse por quê.
 * Some quando não há nada pendente — não é enfeite permanente.
 */
import { useSync } from '../sync/useSync';
import { useSyncStore } from '../sync/store';

export function SyncBadge() {
  const { status, pending, conflicts } = useSyncStore();
  const { sincronizar } = useSync();

  if (pending === 0 && conflicts === 0 && status !== 'syncing') return null;


  const rotulo =
    status === 'syncing'
      ? 'Sincronizando…'
      : conflicts > 0
        ? `${conflicts} ${conflicts === 1 ? 'conflito' : 'conflitos'} para revisar`
        : `${pending} ${pending === 1 ? 'alteração pendente' : 'alterações pendentes'}`;

  return (
    <div className="sync-badge" role="status" aria-live="polite">
      <span className="sync-badge__label">{rotulo}</span>
      {status !== 'syncing' && conflicts === 0 && (
        <button
          type="button"
          className="sync-badge__action"
          onClick={() => void sincronizar()}
        >
          Sincronizar agora
        </button>
      )}
    </div>
  );
}
